(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name fuelPriceReport.controller:FuelPriceReportCtrl
   *
   * @description
   *
   */
  angular
    .module('fuelPriceReport')
    .controller('FuelPriceReportCtrl', FuelPriceReportCtrl);

  function FuelPriceReportCtrl(CommonMasterData,$sce, CommonLogicService) {
    var vm = this;
    vm.ctrlName = 'FuelPriceReportCtrl';
  vm.model = {
			searchPanelToggle : true,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				airport : null
			},
			masterList : {
				airportList : [],
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchFuelPriceReport(params);
		};

		// on change search field
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};
		
		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
			return false;
		}

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// search general flight report
		function searchFuelPriceReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						'fuel_prices.rptdesign', getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate; 
			if (!!param.airport) {
				searchParamMap["airport"] = param.airport.airPortCode;
			} 
			return searchParamMap;
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			// if date invalid
			if (vm.model.masterList.toDateFormatInvalid
					|| vm.model.masterList.fromDateFormatInvalid) {
				return false;
			} else if (istoDateBeforeFromDate()) {
				vm.model.masterList.fromDateAfterToDate = true;
				return false;
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
				return true;
			}
		}

		(function() {
			// load airport list
			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function(error) {
				console.log('Airport List retrieval error!!!');
			});

		})();
	}
}());
